<p-dialog [(visible)]="displayProductSelectionModal" [modal]="true" [responsive]="true" [closable]="false"
    [style]="{ width: '80vw' }" class="product-selection-modal" appendTo="body">
    <ng-template pTemplate="header">
        <div class="p-d-flex w-100 p-jc-between">
            <h5 class="p-mb-0">{{ headerText }}</h5>

            <div class="p-d-flex" *ngIf="isVisibleFilter" style="flex-grow: 1;flex-flow: row-reverse;">
                <span class="p-input-icon-left">
                    <i class="pi pi-search" style="margin-top: -0.75rem;"></i>
                    <input pInputText type="text" [(ngModel)]="productGlobalSearch" style="width: auto;"
                        (input)="onGlobalSearchProduct()" placeholder="Search..." />
                </span>
                <div class="p-grid">
                    <ng-container *ngIf="filterGroup.length > 0">
                        <div class="p-col-1" *ngFor="let s of filterGroup; let i = index;">
                            <div class="p-buttonset" style="white-space: nowrap; width: 100%;">
                                <button pButton pRipple label="{{s?.previewValue}}"
                                    class="p-button-outlined p-button-secondary p-px-1" style="width: 68%;"
                                    [pTooltip]="(s?.category ? s?.category + ': ' : '') + ((s?.value=='Custom' && s?.dateRangeTo && s?.dateRangeFrom)? ((s?.dateRangeFrom | date:'MM/dd/yyyy') +' - '+ (s?.dateRangeTo | date:'MM/dd/yyyy')) : (s?.previewValue))" tooltipPosition="top"
                                    (click)="editFilter(s);addFilter=false;">
                                </button>
                                <button pButton pRipple [disabled]="s?.notRemovable" icon="pi pi-times"
                                    (click)="removeFilter(s,i)" class="p-button-outlined p-button-secondary"></button>
                            </div>
                        </div>
                    </ng-container>
                    <div class="p-col-fixed" style="width:100px" [class.p-ml-2] = "filterGroup.length > 0">
                        <p-button label="Filter" icon="pi pi-plus" iconPos="right"
                            (click)="op.toggle($event);addFilter=true;modifyColumnFilterBy();editFlag=false;"></p-button>
                    </div>
                </div>
            </div>
            <p-overlayPanel #op [showCloseIcon]="true" [style]="{width: '300px'}" 
            styleClass="panel-in-dialog">
            <ng-template pTemplate>
                <label>Filter By</label>
                <p-dropdown [options]="filterBy" class="panelDD" (onChange)="changeFilterOptions()"
                optionLabel="header" placeholder="Select Item" [(ngModel)]="selectedFilterBy"></p-dropdown>
                <label>Options</label>
                <p-dropdown [options]="vertualFilterOptions" class="panelDD" 
                optionLabel="name" [filter]="true" placeholder="Select Item">
                    <ng-template let-obj pTemplate="selectedItem">
                        <ng-container [ngSwitch]="selectedFilterBy?.dataType">
                            <ng-container *ngSwitchCase="'string'">
                                <span pTooltip="{{obj.name}}" tooltipPosition="top">
                                    {{ (obj.name.length>40)? (obj.name | slice:0:40)+'..':(obj.name) }}
                                </span>
                            </ng-container>
                            <ng-container *ngSwitchCase="'datetime'">
                                {{ obj.name | localDate }}
                            </ng-container>
                            <ng-container *ngSwitchCase="'timespan'">
                                {{ obj.name | timeConvert }}
                            </ng-container>
                            <ng-container *ngSwitchCase="'currencySymbol'">
                                {{ obj.name | currencySymbol:'number2dp' }}
                            </ng-container>
                            <ng-container *ngSwitchCase="'percentageSymbol'">
                                {{ obj.name | percentageSymbol }}
                            </ng-container>
                            <ng-container *ngSwitchCase="'secsdhms'">
                                {{ obj.name | secsToDhms }}
                            </ng-container>
                            <ng-container *ngSwitchDefault>
                                {{ obj.name }}
                            </ng-container>
                        </ng-container>
                    </ng-template>
                    <ng-template let-obj pTemplate="item">
                        <ng-container [ngSwitch]="selectedFilterBy?.dataType">
                            <ng-container *ngSwitchCase="'string'">
                                <span pTooltip="{{obj.name}}" tooltipPosition="top">
                                    {{ (obj.name.length>40)? (obj.name | slice:0:40)+'..':(obj.name) }}
                                </span>
                            </ng-container>
                            <ng-container *ngSwitchCase="'datetime'">
                                {{ obj.name | localDate }}
                            </ng-container>
                            <ng-container *ngSwitchCase="'timespan'">
                                {{ obj.name | timeConvert }}
                            </ng-container>
                            <ng-container *ngSwitchCase="'currencySymbol'">
                                {{ obj.name | currencySymbol:'number2dp' }}
                            </ng-container>
                            <ng-container *ngSwitchCase="'percentageSymbol'">
                                {{ obj.name | percentageSymbol }}
                            </ng-container>
                            <ng-container *ngSwitchCase="'secsdhms'">
                                {{ obj.name | secsToDhms }}
                            </ng-container>
                            <ng-container *ngSwitchDefault>
                                {{ obj.name }}
                            </ng-container>
                        </ng-container>
                    </ng-template>
                </p-dropdown>
                <div class="p-text-right">
                    <p-button label="Apply" class="p-mt-2" (onClick)="applyFilter()" *ngIf="addFilter"
                        [disabled]="!selectedFilterBy || !selectedFilterOption"></p-button>
                    <p-button label="Apply" class="p-mt-2" (onClick)="saveFilter()" *ngIf="!addFilter"
                        [disabled]="!selectedFilterBy || !selectedFilterOption"></p-button>
                </div>
            </ng-template>
        </p-overlayPanel>
        </div>
    </ng-template>

    <div class="card">
        <div class="p-grid">
            <div class="p-col-12">
                <p-table #products [columns]="productCols" (onPage)="onPageChange($event)" [value]="allProducts"
                    [(selection)]="selectedProductsList" [lazy]="true" [paginator]="true" [totalRecords]="totalRecord"
                    [rows]="pageSize" [showCurrentPageReport]="true" paginatorDropdownAppendTo="body"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    [rowsPerPageOptions]="tableShowMore" dataKey="id" [selectionMode]="selectionMode" (onRowUnselect)="onRowUnselect($event)">
                    <ng-template pTemplate="caption" *ngIf="!isVisibleFilter">
                        <div class="table-header p-px-0 p-grid" style="background-color: #ddd">
                            <div class="p-col-12 p-md-3">
                                <p-dropdown [options]="productChannels" id="productChannels"
                                    [(ngModel)]="selectedChannel" optionLabel="name" appendTo="body"
                                    (onChange)="onChannelChange()"></p-dropdown>
                            </div>
                            <div class="p-col-12 p-md-3" *ngIf="isVisibleLocation">
                                <p-dropdown [options]="allLocations" [(ngModel)]="selectedLocation" optionLabel="name"
                                    appendTo="body" [filter]="true" (onChange)="onLocationChange()"
                                    placeholder="Select Location"></p-dropdown>
                            </div>
                            <div class="p-col-12 p-md-6">
                                <span class="p-input-icon-left" style="width: 100%">
                                    <i class="pi pi-search"></i>
                                    <input pInputText type="text" [(ngModel)]="productGlobalSearch"
                                        (input)="onGlobalSearchProduct()" placeholder="Search..." />
                                </span>
                            </div>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            <th style="width: 2rem" class="action"><p-tableHeaderCheckbox /></th>
                            <ng-container *ngFor="let col of columns">
                                <th *ngIf="
                                        col.show && col.field == 'description'
                                    " style="width: 300px">
                                    {{ col.header }}
                                </th>
                                <th *ngIf="
                                        col.show && col.field != 'description'
                                    ">
                                    {{ col.header }}
                                </th>
                            </ng-container>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-rowData let-columns="columns">
                        <tr [pSelectableRow]="rowData" [pSelectableRowIndex]="rowIndex">
                            <td class="action">
                                <p-tableCheckbox [value]="rowData" [pSelectableRow]="rowData" />
                            </td>
                            <ng-container *ngFor="let col of columns">
                                <td *ngIf="col.show && col.fieldDataType == 'number'">
                                    {{ rowData[col.field] }}
                                </td>
                                <td *ngIf="col.show && col.fieldDataType == 'qty'">
                                    {{ rowData[col.field] | customNumberFormat: qtyFractionDigits }}
                                </td>
                                <td *ngIf="col.show && col.fieldDataType == 'string'">
                                    {{ rowData[col.field] | shorten: 55}}
                                </td>
                                <td *ngIf="col.show && col.fieldDataType == 'currency'">
                                    @if (baseCurrency && baseCurrency.exchangeRate && baseCurrency.symbol) {
                                        <span>{{ rowData[col.field] | multicurrency: (currencyExchangeRate ?? baseCurrency?.exchangeRate): (currencyUnit?.symbol ?? baseCurrency?.symbol) : fractionDigits }}</span>
                                    } @else {
                                        <span>{{ rowData[col.field] | customNumberFormat: fractionDigits | currencySymbol }}</span>
                                    }
                                </td>
                            </ng-container>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage" let-columns>
                        <tr>
                            <td colspan="12">
                                <div class="p-text-center">
                                    {{ noProductFoundOrLoadingText }}
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </div>
    <p-footer>
        <button type="button" pButton (click)="cancelModal()" label="Cancel" class="p-button-secondary"></button>
        <button type="button" pButton [label]="(selectionMode=='single') ? 'Select' : 'Add'" (click)="addProduct()"
            [disabled]="!selectedProductsList || selectedProductsList?.length == 0"></button>
    </p-footer>
</p-dialog>
